<template>
    <div class="calculator-wrapper" style="overflow-x: hidden;">
    <Skeleton v-if="loading"/>
    <b-container class="tab-content tuition-calculator-page" v-else >
        <b-row>
            <b-col
                cols="12"
                class="d-flex flex-column justify-content-center align-items-center  mb-md-4"
            >
                <div class="logo-wrapper">
                    <img
                        src="../../../assets/img/BAU_Logo.png"
                        :alt="$t('agreement_form_title')"
                        class="img-fluid"
                    />
                </div>
            </b-col>
            <div class="info-box mx-auto mt-3 mb-4 p-4" style="background-color: #f1f3f8; border-left: 6px solid #202c5a; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                <p style="font-size: 25px;font-weight: bold">
                    BAU TUITION & FEES ESTIMATOR
                </p>
                <p style="margin-bottom: 10px;">
                    Your tuition and fees are calculated based on many factors such as your degree level, number of credits, and residency status. Many factors play a part in determining what your final bill looks like such as your major, your campus, how many credits you take and your residency status.<br/>
                </p>
                <p style="margin-bottom: 10px;">
                    The BAU tuition calculator is an easy-to-use tool (it takes about 30 seconds!) that shows you what you can expect to pay. Simply input a few pieces of information into the tuition calculator and see the costs!<br/>
                </p>
                <p style="margin-bottom: 0;">
                    <strong>All fields are required unless marked optional.</strong>
                </p>
            </div>
            <b-tabs id="tab" content-class="mt-3" v-model="tabValue" pills justified card>
                <div v-for="(tabName,index) in tabNames" :key="index">
                    <b-tab :title="tabName" :key="tabName + index">
                      <template #title>
                        <button :class="'btn btn-tab'+(index===tabValue?' tab-active':'')">{{tabName}}</button>
                      </template>
                        <div class="row">
                            <div class="col-md-6">
                                <h3 class="section-title">{{tabName}} Programs</h3>
                                <h4 style="color:#202c5a; margin-bottom: 20px;">Academic Year</h4>

                                <div class="d-flex flex-wrap gap-3 academic-selection-container">
                                    <div
                                        v-for="(academicYear,key) in academicYears"
                                        :key="'academic_year_' + key"
                                        class="academic-card"
                                        :class="{ 'selected': selected_academic_year === academicYear }"
                                        @click="selected_academic_year = academicYear"
                                        style="touch-action: manipulation;"
                                    >
                                        <div class="card-content">
                                            <span class="year-text">{{ academicYear }}</span>
                                            <span class="price-text">
                                                ({{(currencyFormat(semesterTuitionObject[tabName][academicYear]) +'/CREDIT')}})
                                            </span>
                                        </div>
                                        <div class="card-radio">
                                            <div class="radio-indicator" v-if="selected_academic_year === academicYear"></div>
                                        </div>
                                    </div>
                                </div>

                                <h4 style="color:#202c5a; margin-top: 30px;">Registration Type</h4>
                                <div class="mb-3">
                                    <multi-selectbox
                                        :key="'tabName'+tabName"
                                        v-model="registration_type" :multiple="false"
                                        :options="registrationOptionType"
                                    ></multi-selectbox>
                                </div>
                                <div v-if="registration_type === 'regular'" class="mt-3 p-3" style="background-color:#fff8e1; border-left:5px solid #dba631; border-radius:6px;">
                                    <p style="font-size:1rem; margin-bottom:8px;">
                                        <strong>BAU awards all domestic students with a minimum of 35% of tuition assistance.</strong> The tuition estimate is based on this minimum award. You can check if you qualify for higher tuition assistance rates.
                                    </p>
                                </div>

                                <h4 style="color:#202c5a; margin-top: 30px;">Number of Credits Per Year</h4>



                                <div v-if="registration_type === 'regular' || registration_type==='online' || registration_type==='Hybrid'">
                                    <label for="creditsSlider" class="form-label">Select number of credits:</label>
                                    <div style="position: relative; height: 12px; background:#dee2e6; border-radius:6px;">
                                        <div id="filledBar" style="position:absolute; left:0; top:0; height:100%; background:#007bff; border-radius:6px;"></div>
                                        <input type="range" :min="semesterPer.min" :max="semesterPer.max" step="3"
                                               id="creditsSlider"
                                               v-model="per"
                                               :key="'tabName'+tabName"
                                               style="position:absolute; top:-4px; left:0; width:100%; background:none; pointer-events: all; height: 20px;">
                                    </div>
                                    <div class="d-flex justify-content-between mt-1" style="font-size: 0.9rem;">
                                        <span>Part-Time (Min {{semesterPer.min}})</span>
                                        <span>Full-Time ({{semesterPer.max}})</span>
                                    </div>
                                    <div class="mt-2">Selected: <span id="creditsValue">{{per}}</span> credits</div>
                                </div>

                                <div v-else-if="registration_type === 'f1'" class="alert alert-primary">
                                    <div class="d-flex align-items-center">
                                        <i class="fa fa-info-circle mr-2"></i>
                                        <div>
                                            <strong>{{ per }} Credits Per Year</strong>
                                            <div style="font-size: 0.9em;">({{ per / 2 }} credits per semester required for F1 status)</div>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="mt-2">Selected: <span id="creditsValue">{{per}}</span> credits</div>
                                </div>


                                <h4 style="color:#202c5a; margin-top: 30px;">Where Will You Live?</h4>
                                <div class="mb-3">
                                    <div class="d-flex flex-column gap-2">
                                        <div
                                            v-for="(option, index) in housingSelectOptions"
                                            :key="index"
                                            class="academic-card"
                                            :class="{ 'selected': selected_housing === option.value }"
                                            @click="selected_housing = option.value"
                                            style="touch-action: manipulation;"
                                        >
                                            <div class="card-content">
                                                <span class="year-text" style="font-size: 1rem;" v-html="option.text"></span>
                                            </div>
                                            <div class="card-radio">
                                                <div class="radio-indicator" v-if="selected_housing === option.value"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="selected_housing === 'bau' && roomOptions.length > 0" class="mt-3 p-3" style="background: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6;">
                                        <h6 class="mb-2 font-weight-bold">Select Room Type:</h6>
                                        <b-form-radio-group
                                            v-model="selected_room_type"
                                            stacked
                                        >
                                            <b-form-radio v-for="(room, rIndex) in roomOptions" :key="rIndex" :value="room.value" class="mb-2">
                                                {{ room.text }}
                                            </b-form-radio>
                                        </b-form-radio-group>
                                    </div>
                                    <div v-else-if="selected_housing === 'bau'" class="mt-2 text-danger">
                                        No room options available for this selection.
                                    </div>
                                </div>
                                <h4 style="color:#202c5a; margin-top: 30px;">Will You Need a Metro / Bus Pass? <small>(BAU U-PASS Card)</small></h4>
                                <div class="mb-3">
                                    <YesNoSelectbox v-model="bau_card" :key="'tabName'+tabName"
                                    />
                                </div>
                            </div>

                            <div class="col-md-6">
                                <h4 style="color:#202c5a;">Estimated Tuition & Fees</h4>
                                <div class="table-responsive">
                                <table class="table table-bordered mt-3 custom-table-font" style="background:#fff;">
                                    <thead class="bg-light">
                                    <tr>
                                        <th class="align-middle" style="width: 40%; background-color:#202c5a; color:#dba631;">Category</th>
                                        <th class="text-center align-middle" colspan="2" style="background-color:#202c5a; color:#dba631;">Cost Estimate</th>
                                    </tr>
                                    <tr>
                                        <th style="background-color: #dba631; color: #202c5a;"></th>
                                        <th class="text-center" style="background-color: #dba631; color: #202c5a;vertical-align: middle">Per Semester</th>
                                        <th class="text-center" style="background-color: #dba631; color: #202c5a;">Per Academic Year<br><small>({{selected_academic_year}})</small></th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    <template v-for="categoryFee in categoryFees[selectedTabName][selected_academic_year]">
                                        <tr
                                            :key="categoryFee.fee_name"
                                            v-if="categoryFee.fee !== 'tuition' && !categoryFee.skip"
                                        >
                                            <td>
                                                <span>{{ categoryFee.fee_name }}</span>
                                            </td>

                                            <td class="text-center">
                                                <span v-if="categoryFee?.semester_price && categoryFee.semester_price > 0">
                                                    {{currencyFormat(categoryFee.semester_price)}}
                                                </span>
                                                <span v-else-if="categoryFee.explanation">
                                                  {{ categoryFee.explanation }}
                                                </span>
                                            </td>

                                          <td class="text-center">
                                                <span v-if="categoryFee.annual_price > 0">
                                                    {{currencyFormat(categoryFee.annual_price)}}
                                                </span>
                                            <span v-else-if="categoryFee.explanation">
                                                  {{ categoryFee.explanation }}
                                                </span>
                                          </td>
                                        </tr>
                                    </template>

                                    <tr style="border-top: 2px solid #dee2e6;">
                                        <td><strong>Estimated Tuition Required</strong></td>
                                        <td class="text-center">
                                            {{ currencyFormat(calculateTuition / 2) }}
                                        </td>
                                        <td class="text-center">
                                            {{ currencyFormat(calculateTuition) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Estimated Tuition Assistance</strong></td>
                                        <td class="text-center" style="color:red;">
                                            - {{ currencyFormat(calculateTuitionAssistance / 2) }}
                                        </td>
                                        <td class="text-center" style="color:red;">
                                            - {{ currencyFormat(calculateTuitionAssistance) }}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td><strong>Estimated Fees Required</strong></td>
                                        <td class="text-center">
                                            {{ currencyFormat(calculateFeesTotalSemester) }}
                                        </td>
                                        <td class="text-center">
                                            {{ currencyFormat(calculateFeesTotalYear) }}
                                        </td>
                                    </tr>

                                    <tr style="background-color:#1c2d5a; color:#dba631;">
                                        <td><strong>Total Estimated Cost</strong></td>
                                        <td class="text-center"><strong>{{ currencyFormat(calculateGrandTotalSemester) }}</strong></td>
                                        <td class="text-center"><strong>{{ currencyFormat(calculateTotal) }}</strong></td>
                                    </tr>

                                    </tbody>
                                </table>
                                </div>



                                <p class="mt-3" style="font-size:1rem;">
                                    <template v-if="registration_type === 'regular'">
                                        You may be eligible for additional tuition assistance based on your CGPA. Check
                                        <a href="https://bau.edu/admissions/scholarships-tuition-assistance-program/" target="_blank" style="color:blue">HERE</a>
                                        for all tuition assistance programs.
                                    </template>
                                    <template v-else>
                                        Only one type of tuition assistance will be applied. Check
                                        <a href="https://bau.edu/admissions/scholarships-tuition-assistance-program/" target="_blank" style="color:blue">HERE</a>
                                        for all tuition assistance programs.
                                    </template>
                                </p>

                                <p class="mt-1" style="font-size:1rem;">
                                    For a full list of tuition and fees, visit:
                                    <a href="https://bau.edu/admissions/tuition-fees/" target="_blank" style="color:blue">https://bau.edu/admissions/tuition-fees/</a>
                                </p>
                            </div>
                        </div>
                    </b-tab>
                </div>
            </b-tabs>
            <div class="info-box mx-auto mt-5 mb-4 p-4" style="background-color: #f1f3f8; border-left: 6px solid #202c5a; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.05);">
                <p style="margin-bottom: 10px;">
                    <strong>Disclaimers</strong>
                </p>
                <p style="margin-bottom: 0; line-height: 1.6;">
                  <strong>This is not a bill.</strong> This is only an estimate. All amounts shown here or in other BAU publications or web pages represent tuition and fees as currently approved. However, BAU reserves the right to increase or modify tuition and fees without prior notice, upon approval by the BAU Board of Trustees or as otherwise consistent with Board policy, and to make such modifications applicable to students enrolled at BAU at that time as well as to incoming students. In addition, all tuition amounts and fees are subject to change at any time for correction of errors. Finally, please note that fee amounts billed for any period may be adjusted at a future date.
                </p>
            </div>
        </b-row>

        <!-- Lead Generation Popup -->
        <transition name="popup-fade">
            <div v-if="showLeadPopup" class="lead-popup-overlay" @click.self="closeLeadPopup">
            <div class="lead-popup-card">
                <!-- Close Button - kartın içinde, sağ üst köşede -->
                <div class="lead-popup-header">
                    <button type="button" class="lead-popup-close" @click.prevent="closeLeadPopup" aria-label="Close">
                        &times;
                    </button>
                </div>

                <div class="lead-popup-body">
                    <h2 class="lead-popup-title">Your future at BAU is within reach.</h2>
                    <p class="lead-popup-subtitle">
                        You've done the math - now let's see the impact. If you're excited about our programs and want a more detailed look at your enrollment path, fill this out and we'll be in touch.
                    </p>

                    <div
                        v-if="!leadFormSubmitted"
                        class="lead-popup-form"
                    >
                        <div class="lead-form-group">
                            <label>First Name <span class="required">*</span></label>
                            <input
                                type="text"
                                name="firstname"
                                autocomplete="given-name"
                                v-model="leadForm.firstname"
                                placeholder="First Name"
                                required
                            />
                        </div>

                        <div class="lead-form-group">
                            <label>Last Name <span class="required">*</span></label>
                            <input
                                type="text"
                                name="lastname"
                                autocomplete="family-name"
                                v-model="leadForm.lastname"
                                placeholder="Last Name"
                                required
                            />
                        </div>

                        <div class="lead-form-group">
                            <label>Email <span class="required">*</span></label>
                            <input
                                type="email"
                                name="email"
                                autocomplete="email"
                                v-model="leadForm.email"
                                placeholder="Email"
                                required
                            />
                        </div>

                        <div class="lead-form-group">
                            <label>Phone <span class="required">*</span></label>
                            <PhoneNumberInput v-model="leadForm.phone" />
                        </div>

                        <button @click="submitLeadForm" class="lead-popup-submit" :disabled="leadFormLoading" style="touch-action: manipulation;">
                            <span v-if="leadFormLoading">Sending...</span>
                            <span v-else>Let's Get Started</span>
                        </button>

                        <p class="lead-popup-disclaimer">
                            * By submitting this form, you consent to the personal data provided above to be processed, used, and/or retained by Bay Atlantic University and its members, officers, employees, and representatives for communication, promotional, and marketing purposes.
                        </p>
                    </div>

                    <!-- Success State -->
                </div>
            </div>
        </div>
    </transition>
     </b-container>
    </div>

</template>
<script>
import TuitionCalculatorServices from "@/services/TuitionCalculatorServices";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import YesNoSelectbox from "@/components/interactive-fields/YesNoSelectbox.vue";
import Skeleton from "@/modules/TuitionCalculator/pages/Skeleton.vue";
import PhoneNumberInput from "@/components/elements/PhoneNumberInput.vue";


export default {
    components: {YesNoSelectbox, MultiSelectbox, Skeleton, PhoneNumberInput},
    data(){
        return {
            calculatorInformation: [],
            loading:false,
            selected_academic_year: null,
            registration_type: null,
            selected_housing:null,
            selected_room_type: null,
            bau_card:null,
            tabValue:0,
            popupTimerId:null,
            semesterTuition:null,
            semesterTuitionObject:null,
            semesterHousingPrice:0,
            month:12,
            semesterStudentIdCartPrice:0,
            semesterTransportationPrice:0,
            categoryFees:null,
            housingSelectOptions:[
                {
                    text:'BAU Student Housing (Island Condos) - <span style="color:red; font-weight:bold;">depending on availability</span>',
                    value:'bau'
                },
                {
                    text:'I will arrange my own accommodation',
                    value:'own'
                },
            ],
            per:9,
            leadPopupShown: false,
            showLeadPopup: false,
            leadFormSubmitted: false,
            leadFormLoading: false,
            observer: null,
            leadForm: {
                firstname: '',
                lastname: '',
                email: '',
                phone: ''
            }
        }
    },
    metaInfo() {
        return {
            title: this.$t('tuition_calculator')
        }
    },
    created() {
        this.startTimer()
        this.getCalculatorInformation()
    },

    beforeDestroy() {
        if (this.popupTimerId){
            clearTimeout(this.popupTimerId);
            this.popupTimerId = null;
        }
    },
    computed:{
        roomOptions() {
            if (this.categoryFees && this.selectedTabName && this.selected_academic_year) {
                const fees = this.categoryFees[this.selectedTabName][this.selected_academic_year];
                if (fees) {
                    const housingFee = fees.find(f => f.fee === 'housing');
                    if (housingFee && housingFee.options && Array.isArray(housingFee.options)) {
                        return housingFee.options;
                    }
                }
            }
            return [];
        },
        semesterPer(){
            let selectedPer
            const  undergraduatePer= {
                min:9,
                max:30
            }

            let graduateType= {
                min:6,
                max:21
            }
            if (this.selectedTabName==='Undergraduate'){
                selectedPer=undergraduatePer
            }else if (this.selectedTabName==='Graduate'){
                selectedPer=graduateType
            }else{
                selectedPer={min:9, max:30}
            }
            return selectedPer

        },
        registrationOptionType(){
            let optionType=[]
            const undergraduateType= [
                {
                    text: 'F-1 International',
                    value: 'f1',
                    discount:35
                },
                {
                    text: 'Domestic & Other Non-F1 Students',
                    value: 'regular',
                    discount: 35
                },
            ]
            const graduateType=[
                {
                    text: 'F-1 International',
                    value: 'f1',
                    discount:35
                },
                {
                    text: 'Domestic & Other Non-F1 Students',
                    value: 'regular',
                    discount: 35
                },
                {
                    text: 'Online',
                    value: 'online',
                    discount: 35
                },
                {
                    text: 'Hybrid',
                    value: 'Hybrid',
                    discount: 20
                },
            ]
            if (this.selectedTabName==='Undergraduate'){
                optionType.push(...undergraduateType)
            }else if (this.selectedTabName==='Graduate'){
                optionType.push(...graduateType)
            }else{
                optionType.push([])
            }
            return optionType
        },
        selectedTabName(){
            if (this.tabValue > -1){
                return this.tabNames[this.tabValue]
            }else {
                return this.tabNames[this.tabValue+1]
            }
        },
        tabNames(){
            if (this.calculatorInformation.length > 0){
                const levels= this.calculatorInformation.map(item=>item.level_name)
                return [...new Set(levels)]
            }else {
                return  []
            }
        },
        academicYears(){
            if (this.calculatorInformation.length > 0){
                let tabName
                if (this.tabValue > -1){
                    tabName=this.tabNames[this.tabValue]
                }else {
                    tabName=this.tabNames[this.tabValue+1]
                }
                const academicYears= this.calculatorInformation.filter(item=>item.level_name===tabName).map(item=>item.academic_year)

                return  [...new Set(academicYears)]

            }else {
                return  []
            }
        },
        // --- HESAPLAMA MANTIĞI GÜNCELLEMELERİ ---

        // YILLIK HARÇLAR TOPLAMI (Estimated Fees Required - Annual)
        calculateFeesTotalYear() {
            if (!this.categoryFees || !this.categoryFees[this.selectedTabName]) return 0;
            const fees = this.categoryFees[this.selectedTabName][this.selected_academic_year];
            if (!fees) return 0;

            let total = 0;
            fees.forEach(item => {
              if(['credit','month'].includes(item.per) || item.skip) {
                // Aylık veya Kredi bazlı ücretleri dönemlik hesaba katmıyoruz
                return;
              }
              if (item.fee === 'transportation' && !this.bau_card) return;
              total += Number(item.annual_price);
            });
            return total;
        },

        // DÖNEMLİK HARÇLAR TOPLAMI (Estimated Fees Required - Semester)
        calculateFeesTotalSemester() {
            if (!this.categoryFees || !this.categoryFees[this.selectedTabName]) return 0;
            const fees = this.categoryFees[this.selectedTabName][this.selected_academic_year];
            if (!fees) return 0;

            let total = 0;
            fees.forEach(item => {
                if(['credit','month'].includes(item.per) || item.skip) {
                  // Aylık veya Kredi bazlı ücretleri dönemlik hesaba katmıyoruz
                  return;
                }
                if (item.fee === 'transportation' && !this.bau_card) return;

                total += Number(item?.semester_price??0);
            });
            return total;
        },

        // DÖNEMLİK GENEL TOPLAM (Estimated Total Cost - Semester)
        calculateGrandTotalSemester() {
            const tuition = this.calculateTuition / 2;
            const aid = this.calculateTuitionAssistance / 2;
            const fees = this.calculateFeesTotalSemester;
            const housingObject=this.categoryFees[this.selectedTabName][this.selected_academic_year].find(item=>{
                return item.fee==='housing'
            });
            const housing = housingObject?.semester_price ?? 0;
            // const housing = this.categoryFees[this.selectedTabName][this.selected_academic_year].filter(item=>{
            //   return item.fee==='housing'
            // })[0].semester_price ?? 0;
            return tuition + fees + housing - aid;
        },

        // YILLIK GENEL TOPLAM (Estimated Total Cost - Annual)
        calculateTotal(){
            // Mevcut fonksiyonu koruyoruz, ancak mantığı verify ediyoruz.
            // Fees + Tuition - Aid
            const housingObj = this.categoryFees[this.selectedTabName][this.selected_academic_year].find(item=>{
              return item.fee==='housing'
            })
            const housing=housingObj?.annual_price ?? 0;
            return this.calculateFeesTotalYear + this.calculateTuition + housing - this.calculateTuitionAssistance;
        },

        calculateTuition(){
            if (this.categoryFees[this.selectedTabName][this.selected_academic_year].length>0){
                let price=0
                this.categoryFees[this.selectedTabName][this.selected_academic_year].forEach(item=>{
                    if (item.fee==="tuition"){
                        if (this.registration_type==='dual'){
                            price=0
                        }else {
                            price+=Number(item.price)*Number(this.per)
                        }
                    }
                })
                return Number(price)
            }else{
                return  0
            }
        },
        calculateTuitionAssistance(){
            let selectedDiscount = this.registrationOptionType.filter(item=>item.value===this.registration_type)[0]?.['discount']
            let discountRate=0
            if (selectedDiscount){
                discountRate=(this.calculateTuition * Number(selectedDiscount))/100
            }
            return Number(discountRate)
        },
    },
    watch:{
        tabValue(){
            if (this.academicYears.length > 0){
                this.selected_academic_year=this.academicYears[0]
            }
        },
        selectedTabName(value){
            if (value){
                if(this.registration_type === 'f1') {
                    if (value === 'Undergraduate') {
                        this.per = 30;
                    } else if (value === 'Graduate') {
                        this.per = 18;
                    }
                } else {
                    this.per = this.semesterPer.min
                }
            }
        },
        registration_type(newVal) {
            if (newVal === 'f1') {
                if (this.selectedTabName === 'Undergraduate') {
                    this.per = 30;
                } else if (this.selectedTabName === 'Graduate') {
                    this.per = 18;
                }
            } else if (newVal === 'regular') {
                this.per = this.semesterPer.min;
            }
        },
        selected_housing(newValue){
            let newCategoryFees;
            if (newValue==='own'){
                this.selected_room_type = null;
                newCategoryFees=this.categoryFees[this.selectedTabName][this.selected_academic_year].map((item)=>{
                    if (item.fee==='housing'){
                        item.skip=true
                      item.semester_price=0;
                      item.annual_price=0;
                    }
                    return item
                })
                this.categoryFees[this.selectedTabName][this.selected_academic_year]=newCategoryFees

            }else{
                newCategoryFees=this.categoryFees[this.selectedTabName][this.selected_academic_year].map((item)=>{
                    if (item.fee==='housing'){
                        item.skip=true
                    }
                    return item
                })
                this.categoryFees[this.selectedTabName][this.selected_academic_year]=newCategoryFees
            }
        },
        selected_room_type(newVal) {
            if(newVal && this.selected_housing === 'bau') {
                let newCategoryFees=this.categoryFees[this.selectedTabName][this.selected_academic_year].map((item)=>{
                    if (item.fee==='housing'){
                        return {
                            ...item,
                            annual_price: Number(newVal) * 12,
                            semester_price: Number(newVal) * 4,
                            skip: false
                        }
                    }
                    return item
                })
                this.categoryFees[this.selectedTabName][this.selected_academic_year]=newCategoryFees
            }
        },
        selected_academic_year(){
            const feesArray = this.categoryFees[this.selectedTabName][this.selected_academic_year];
            feesArray.forEach(item => {
                switch (item.fee) {
                    case 'housing':
                        this.semesterHousingPrice = item.price;
                        break;
                    case 'transportation':
                        this.semesterTransportationPrice = item.price;
                        break;
                    case 'tuition':
                        this.semesterTuition = item.price;
                        break;
                }
            });
            this.setNull()
        },
        bau_card(newValue){
            let newCategoryFees
            if (newValue==='Yes'){
                newCategoryFees=this.categoryFees[this.selectedTabName][this.selected_academic_year].map((item)=>{
                    if (item.fee==='transportation'){
                        item.skip=false
                    }
                    return item
                })
                this.categoryFees[this.selectedTabName][this.selected_academic_year]=newCategoryFees
            }else{
                newCategoryFees=this.categoryFees[this.selectedTabName][this.selected_academic_year].map((item)=>{
                    if (item.fee==='transportation'){
                        item.skip=true
                    }
                    return item
                })
                this.categoryFees[this.selectedTabName][this.selected_academic_year]=newCategoryFees
            }
        }
    },
    methods:{
        setNull(){
            this.selected_housing=null
            this.bau_card=null
            this.selected_room_type=null
        },
        createdProgramsInformation(){
            let newObject={}
            let semesterTuitionObject={}
            this.calculatorInformation.forEach(item=>{
                if (!newObject[item.level_name]){
                    this.$set(newObject,item.level_name,{})
                }
                if (!newObject[item.level_name][item.academic_year]){
                    this.$set(newObject[item.level_name],item.academic_year,[])
                }
                let semesterPrice=item.price, annualPrice=item.price
                if(item.per==='month'){
                    annualPrice=item.price * 12
                    semesterPrice=item.price * 4
                }
                else if(item.per==='semester'){
                    annualPrice=item.price * 2
                }
                let skip=false
                if(item.fee==='transportation' || item.fee==='housing') {
                  skip = true
                }
                newObject[item.level_name][item.academic_year].push({
                    fee:item.fee,
                    fee_name:item.fee_name,
                    per:item.per,
                    explanation:item.explanation,
                    price:item.price,
                    skip:skip,
                    annual_price:annualPrice,
                    semester_price:semesterPrice,
                    options: item.options ? item.options : []
                })
                newObject[item.level_name][item.academic_year].sort((a,b)=>{
                    const nameA =a.fee_name.toLowerCase()
                    const nameB =b.fee_name.toLowerCase()
                    if (nameA < nameB) return -1
                    if (nameA > nameB) return 1
                    return 0
                })

                if (!semesterTuitionObject[item.level_name]){
                    this.$set(semesterTuitionObject,item.level_name,{})
                }
                if (!semesterTuitionObject[item.level_name][item.academic_year]){
                    this.$set(semesterTuitionObject,item.academic_year,{})
                }
                if (item.fee==='tuition'){
                    semesterTuitionObject[item.level_name][item.academic_year]=item.price
                }
            })
            this.selected_academic_year=this.academicYears[0]
            this.categoryFees=newObject
            this.semesterTuitionObject=semesterTuitionObject
        } ,

        closeLeadPopup() {
            this.showLeadPopup = false;
            if (this.popupTimerId){
                clearTimeout(this.popupTimerId);
                this.popupTimerId=null
            }
        },
        async submitLeadForm() {
            this.leadFormLoading = true;
            try {
                await TuitionCalculatorServices.modalFormSave(this.leadForm)
                this.showLeadPopup = false;
                this.$toast.success(this.$t('We will be in touch soon with more details about your enrollment path at BAU.'));
                this.leadFormSubmitted = true;
            } catch (err) {
                this.showErrors(err);
            } finally {
                this.leadFormLoading = false;
            }
        },
        async getCalculatorInformation(){
            try {
                this.loading=true
                const res =await TuitionCalculatorServices.getCalculatorInformation()
                this.calculatorInformation = res.data.data.sort((a, b) => {
                    const yilKarsilastirmasi = a.academic_year.localeCompare(b.academic_year);
                    if (yilKarsilastirmasi !== 0) {
                        return yilKarsilastirmasi;
                    }
                    return a.level_rank - b.level_rank;
                });
                this.createdProgramsInformation()
            }catch (err){
                this.showErrors(err)
            }finally{
                this.loading=false}
        },
        startTimer(){
            this.popupTimerId =setTimeout(()=>{
                this.showLeadPopup=true
            },20000)
        }
    }
}
</script>
<style scoped>
body {
    margin: 20px;
}
.tuition-calculator-page {
    font-family: "Futura PT", sans-serif;
}

.custom-table-font {
    font-size: 1rem !important;
}
.custom-table-font td {
    padding: 12px;
    vertical-align: middle;
}

.tuition-calculator-page ::v-deep .nav-tabs .nav-link.active,
.tuition-calculator-page ::v-deep .nav-tabs .nav-item.show .nav-link {
    color: #dba631 !important;
    border-bottom: 3px solid #dba631;
}
.tuition-calculator-page ::v-deep .nav-tabs .nav-link {
    padding: 0;
    padding-bottom: 0.930rem;
    color: #1c2d5a !important;
    margin-bottom: -1px;
    transition: all 0.2s ease;
}


.tab-content {
    background: white;
    border-radius: 0 0 12px 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* =========================================================================
   Mobil Responsive Düzeltmeleri
   ========================================================================= */
@media (max-width: 576px) {
    .tab-content {
        padding: 16px 12px;
    }

    .custom-table-font {
        font-size: 0.82rem !important;
    }
    .custom-table-font td {
        padding: 8px 6px;
    }

    .btn-tab {
        font-size: 16px !important;
        height: 48px !important;
    }

    .info-box {
        padding: 16px !important;
    }
}

.section-title {
    color: #202c5a;
    position: relative;
    padding-left: 15px;
    margin-bottom: 30px;
}

.section-title::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background-color: #007bff;
    border-radius: 2px;
}

.academic-selection-container {
    margin-bottom: 20px;
}

/* min-width kaldırıldı — mobilde yatay taşmayı engeller */
.academic-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 15px 20px;
    cursor: pointer;
    background-color: #fff;
    transition: all 0.2s ease-in-out;
    flex: 1;
    min-width: 0;
    position: relative;
}

.academic-card:hover {
    border-color: #b0b5c1;
}

.academic-card.selected {
    border: 2px solid #202c5a;
    background-color: #fcfdff;
}

.card-content {
    display: flex;
    flex-direction: column;
    max-width: 85%;
}

.year-text {
    font-weight: bold;
    color: #202c5a;
    font-size: 1.1rem;
    margin-bottom: 4px;
}

.price-text {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
}

.card-radio {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 2px solid #ccc;
    margin-left: 15px;
}

.academic-card.selected .card-radio {
    border-color: #202c5a;
}

.radio-indicator {
    width: 12px;
    height: 12px;
    background-color: #202c5a;
    border-radius: 50%;
}

.scroll-trigger-point {
    width: 100%;
    height: 1px;
    opacity: 0;
    pointer-events: none;
}

/* =========================================================================
   Lead Generation Popup Styles
   ========================================================================= */

/* Overlay Background — mobilde scroll için overflow-y: auto */
.lead-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.65);
    display: flex;
    justify-content: center;
    align-items: flex-start; /* mobilde yukarıdan başlasın, scroll edilebilsin */
    overflow-y: auto;
    padding: 20px 0;
    z-index: 105000;
    pointer-events: auto;
    -webkit-overflow-scrolling: touch;
}

@media (min-height: 700px) {
    .lead-popup-overlay {
        align-items: center; /* yeterli yükseklikte ortala */
    }
}

/* Card Container */
.lead-popup-card {
    background: #fff;
    width: 92%;
    max-width: 450px;
    border-radius: 12px;
    padding: 0;
    position: relative;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    pointer-events: auto;
    overflow: hidden; /* içerik taşmasın */
    margin: auto; /* overlay scroll içinde ortalansın */
}

/* Header — close butonunun bulunduğu alan */
.lead-popup-header {
    display: flex;
    justify-content: flex-end;
    padding: 12px 12px 0 12px;
}

.lead-popup-body {
    padding: 16px 24px 24px 24px;
}

/* Close Button — artık kart içinde, overflow sorunu yok */
.lead-popup-close {
    width: 36px;
    height: 36px;
    background-color: #e09f2c;
    color: #fff;
    border: none;
    border-radius: 50%;
    font-size: 22px;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    touch-action: manipulation;
}

.lead-popup-close:hover {
    background-color: #c98b25;
}

/* Header Text */
.lead-popup-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-bottom: 10px;
}

.lead-popup-subtitle {
    font-size: 0.9rem;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
    line-height: 1.4;
}

/* Form Styles */
.lead-popup-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.lead-form-group {
    display: flex;
    flex-direction: column;
}

.lead-form-group label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 5px;
}

.lead-form-group input {
    width: 100%;
    padding: 10px 12px;
    border: none;
    background-color: #f2f2f2;
    border-radius: 6px;
    /* iOS otomatik zoom'u önlemek için minimum 16px — kritik! */
    font-size: 16px;
    color: #333;
    touch-action: manipulation;
}

.lead-form-group input:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(224, 159, 44, 0.4);
}

/* Submit Button */
.lead-popup-submit {
    margin-top: 10px;
    width: 100%;
    padding: 12px;
    background-color: #e09f2c;
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.lead-popup-submit:hover:not(:disabled) {
    background-color: #c98b25;
}

.lead-popup-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.lead-popup-disclaimer {
    margin-top: 15px;
    font-size: 0.75rem;
    color: #888;
    line-height: 1.3;
    font-style: italic;
    text-align: justify;
}

.lead-popup-success {
    text-align: center;
    padding: 20px 0;
}

.lead-popup-success .success-icon {
    font-size: 3rem;
    color: #4CAF50;
    margin-bottom: 15px;
}

.popup-fade-enter-active, .popup-fade-leave-active {
    transition: opacity 0.3s ease;
}
.popup-fade-enter, .popup-fade-leave-to {
    opacity: 0;
}
.btn-tab{
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  color: #202c5a;
  height: 60px;
  font-size: 24px;
}
.tab-active {
  background-color: #202c5a;
  color: #ffffff;
}
</style>
